module.exports = __webpack_public_path__ + "static/media/55 - Logo PPI Rotterdam.846df7a8.png";